import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary text-subtitle2 text-uppercase q-mb-sm" }, " Cancel Request ", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-7" }
const _hoisted_5 = { class: "col text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cancel_request_btn = _resolveComponent("cancel-request-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (_ctx.request.creatorType === 'system')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " This request cannot be cancelled because it was automatically created by the system. "))
      : (_ctx.request.creatorType === 'user')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, " Cancel the request if you no longer require new " + _toDisplayString(_ctx.platform) + " posts. ", 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_cancel_request_btn, {
                request: _ctx.request,
                onCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('canceled')))
              }, null, 8, ["request"])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}